import {createSlice} from "@reduxjs/toolkit";
import {isObjectEmpty} from "../../helpers/objectHelper";

const initialState = {
  processing: false,
  province: {
    loading: false,
    error: '',
    data: [],
  },
  city: {
    loading: false,
    error: '',
    data: [],
  },
  area: {
    loading: false,
    error: '',
    data: [],
  },
  currentProvince: {},
  currentCity: {},
  currentArea: {},
  toggle: false
}

const locationSlice = createSlice({
  name: "locationSlice",
  initialState,
  reducers: {
    setCurrentProvince: (state, action) => {
      state.currentProvince = action.payload
    },
    setCurrentCity: (state, action) => {
      state.currentCity = action.payload
    },
    setCurrentArea: (state, action) => {
      state.currentArea = action.payload
    },
    setProcessing: (state, action) => {
      state.processing = action.payload
    },
    fetchProvinces: (state, action) => {
    },
    setProvince: (state, action) => {
      const {loading, error, data} = action.payload
      state.province.loading = loading ?? state.province.loading
      state.province.error = error ?? state.province.error
      state.province.data = data ?? state.province.data
      if (data && data.length && isObjectEmpty(state.currentProvince)) {
        state.currentProvince = data[0]
      }
    },
    renameProvince: () => {
    },
    enableDisableProvince: () => {
    },
    updateProvince: (state, action) => {
      const {province} = action.payload
      const targetProvince = state.province.data.find((p) => p.id === province.id)
      targetProvince.name = province.name;
      state.currentProvince = province;
    },
    fetchCitiesByProvince: (state, action) => {
    },
    addCities: (state, action) => {
    },
    setCity: (state, action) => {
      const {loading, error, data, isAdding} = action.payload
      state.city.loading = loading ?? state.city.loading
      state.city.error = error ?? state.city.error
      state.city.data = (isAdding ? [...state.city.data, ...data] : data) ?? state.city.data
      if (data && data.length) {
        state.currentCity = data[0]
      }
    },
    renameCity: () => {
    },
    enableDisableCity: () => {
    },
    updateCity: (state, action) => {
      const {city} = action.payload
      const targetCity = state.city.data.find((p) => p.id === city.id)
      targetCity.name = city.name
      state.currentCity = city;
    },
    fetchAreasByCity: (state, action) => {
    },
    addAreas: (state, action) => {
    },
    setArea: (state, action) => {
      const {loading, error, data, isAdding} = action.payload
      state.area.loading = loading ?? state.area.loading
      state.area.error = error ?? state.area.error
      state.area.data = (isAdding ? [...state.area.data, ...data] : data) ?? state.area.data
      if (data && data.length) {
        state.currentArea = data[0]
      } else {
        state.currentArea = {}
      }
    },
    modifyArea: (state, action) => {
    },
    enableDisableArea: () => {
    },
    updateArea: (state, action) => {
      const {area} = action.payload
      const targetArea = state.area.data.find((a) => a.id === area.id)
      const index = state.area.data.indexOf(targetArea)
      state.area.data[index] = area
      state.currentArea = area
    },
    bulkUpdate: (state, action) => {
    },
    toggleSwitch: (state, action) => {
      const {data: {disabled, campaign_location}, locationType, locationId} = action.payload
      if (locationType === "Province") {
        state.province.data = state.province.data.map((province) =>
          (province.id === locationId) ?
            ({
              ...province,
              ...(!!disabled !== undefined && {disabled}),
              ...(!!campaign_location !== undefined && {campaign_location})
            })
            : province
        )
        if (campaign_location != undefined) {
          state.currentProvince.campaign_location = campaign_location;
          state.currentCity.campaign_location = campaign_location
          state.currentArea.campaign_location = campaign_location
          state.city.data.forEach((a) => a.campaign_location = campaign_location)
          state.area.data.forEach((a) => a.campaign_location = campaign_location)
        }
        if (disabled != undefined) {
          state.currentProvince.disabled = disabled
          state.currentCity.disabled = disabled
          state.currentArea.disabled = disabled
          state.city.data.forEach((a) => a.disabled = disabled)
          state.area.data.forEach((a) => a.disabled = disabled)
        }
      } else if (locationType === "City") {
        state.city.data = state.city.data.map((c) =>
          (c.id === locationId) ?
            ({
              ...c,
              ...(disabled !== undefined && {disabled}),
              ...(campaign_location !== undefined && {campaign_location})
            })
            : c
        )

        if (campaign_location != undefined) {
          state.currentCity.campaign_location = campaign_location
          state.currentArea.campaign_location = campaign_location
          state.area.data.forEach((a) => a.campaign_location = campaign_location)
        }
        if (disabled != undefined) {
          state.currentCity.disabled = disabled
          state.currentArea.disabled = disabled
          state.area.data.forEach((a) => a.disabled = disabled)
        }
      } else {
        state.area.data = state.area.data.map((a) =>
          (a.id === locationId) ?
            ({
              ...a,
              ...(disabled !== undefined && {disabled}),
              ...(campaign_location !== undefined && {campaign_location})
            })
            : a
        )
        if (campaign_location != undefined) {
          state.currentArea.campaign_location = campaign_location
        }
        if (disabled != undefined) {
          state.currentArea.disabled = disabled
        }
      }
    },
    toggleStatus: (state, action) => {
      state.toggle = !state.toggle;
      state.currentProvince = {};
      state.currentCity = {};
      state.currentArea = {};
    }
  }
})

export const {
  setCurrentProvince,
  setCurrentCity,
  setCurrentArea,

  setProcessing,
  fetchProvinces,
  setProvince,
  renameProvince,
  enableDisableProvince,
  updateProvince,
  fetchCitiesByProvince,
  addCities,
  setCity,
  renameCity,
  enableDisableCity,
  updateCity,
  fetchAreasByCity,
  addAreas,
  setArea,
  modifyArea,
  enableDisableArea,
  updateArea,
  bulkUpdate,
  toggleSwitch,
  toggleStatus
} = locationSlice.actions;

export default locationSlice.reducer;
